import { useEffect } from 'react';

import type { ICursorArgs } from './models';
import { getNextNumPosition } from './helpers';

export const useCursorPosition = (options: ICursorArgs) => {
    const { hasFocus, inputRef, isDeleting, maskOptions, position } = options;
    const nextNumPosition = getNextNumPosition(options);

    useEffect(() => {
        if (!hasFocus.current) return;

        const { current: input } = inputRef;
        if (!input) return;

        const { selectionStart: nativePosition } = input;

        // isDirectTyping введение ли символов в конец, а не в середину
        const isDirectTyping = nativePosition === nextNumPosition;

        if (nativePosition && isDirectTyping && !isDeleting) {
            input.setSelectionRange(nativePosition, nativePosition);
        } else if (position && isDeleting) {
            input.setSelectionRange(position, position);
        } else if (nextNumPosition) {
            input.setSelectionRange(nextNumPosition, nextNumPosition);
        }
    }, [position, inputRef, maskOptions, hasFocus, nextNumPosition, isDeleting]);
};
